// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"181":"7d222977","782":"7d222977"}[chunkId] + ".chunk.css";
};